import React from 'react';
import classNames from 'classnames';
import PackageCard from "./PackageCard";
import BottomArea from "./BottomArea";
import ServicesSection from "./ServicesSection";
import ServiceItem from "./ServiceItem";
import { makeSectionsFromServices } from "./makeSectionsFromServices";
import styles from "./PackageSelector.module.scss";
import { utils } from "../../../utils";
const sectionTitle = (id, sum) => {
  if (id === 'optional') {
    return 'Optional services';
  } else if (id === 'variable') {
    return 'Variable';
  } else if (sum != null) {
    return utils.formatDollarAmount(sum);
  }
};
export default function PackageSelector(_ref) {
  let {
    packages,
    selectedBundleID,
    isMobile = false,
    CUSTOM_BRANDING,
    onSelect
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames(styles.packagesList, {
      [styles.mobile]: isMobile
    })
  }, packages.map((_ref2, idx) => {
    let {
      id,
      name,
      services
    } = _ref2;
    const bundleTestPrefix = "package-".concat(id);
    return /*#__PURE__*/React.createElement(PackageCard, {
      key: id,
      id: id,
      name: name,
      "data-testid": "package-card-".concat(idx),
      bottomArea: /*#__PURE__*/React.createElement(BottomArea, {
        selected: id === selectedBundleID,
        "data-testid": bundleTestPrefix,
        CUSTOM_BRANDING: CUSTOM_BRANDING,
        onClick: () => onSelect(id)
      })
    }, makeSectionsFromServices(services).map(_ref3 => {
      let {
        id,
        services,
        category,
        subtitle,
        sum,
        hasOptionalServices,
        id: sectionID
      } = _ref3;
      return /*#__PURE__*/React.createElement(ServicesSection, {
        key: sectionID,
        hasOptionalServices: hasOptionalServices,
        title: sectionTitle(id, sum),
        subtitle: subtitle,
        category: category,
        "data-testid": "".concat(bundleTestPrefix, "-section-").concat(sectionID)
      }, services.map(_ref4 => {
        let {
          id: serviceID,
          name,
          description,
          variablePriceText
        } = _ref4;
        return /*#__PURE__*/React.createElement(ServiceItem, {
          key: serviceID,
          name: name,
          description: description,
          variablePriceText: variablePriceText,
          "data-testid": "".concat(bundleTestPrefix, "-service-").concat(serviceID)
        });
      }));
    }));
  }));
}